<template>
  <div class="outer-container" id="jobseeker">
    <div>
      <div class="ucontainer">
        <h2 class="text-center  heading_fonts" style="padding-bottom:20px">
          Please click on the assessment test

          <br />
          below which suits your skill sets.
        </h2>

        <div class="grid">
          <div class="border-radius">
            <img
              class="mx-wd"
              src="../../assets/homeV2/business-man-expanding-futuristic-virtual-screen-modern-tablet.png"
              alt=""
            />
            <div class="" @click="openData()">
              <h3 class="marnope pt-1 cursor-pointer" style="color:#2465F3">
                Data Science >
              </h3>
              <modal name="datas" :adaptive="true" width="60%" height="auto">
                <MoreInfo :info="dataScience" />
              </modal>
            </div>

            <!-- start -->

            <!-- end -->
          </div>
          <div class="border-radius">
            <img
              class="mx-wd"
              src="../../assets/homeV2/working-desk-with-hands-sketching-screens-mobile-responsive-website-development-with-ui-ux.png"
              alt=""
            />
            <div class="" @click="openUx()">
              <h3 class="marnope pt-1 cursor-pointer" style="color:#2465F3">
                UX UI >
              </h3>
              <modal name="uxui" :adaptive="true" width="60%" height="auto">
                <MoreInfo :info="UXUI" />
              </modal>
            </div>
          </div>
          <div class="border-radius">
            <img
              class="mx-wd"
              src="../../assets/homeV2/online-web-design.png"
              alt=""
            />

            <div class="" @click="openFront()">
              <h3 class="marnope pt-1 cursor-pointer" style="color:#2465F3">
                Front End >
              </h3>
              <modal name="front" :adaptive="true" width="40%" height="auto">
                <MoreInfo :info="frontEnd" />
              </modal>
            </div>
          </div>

          <div class="border-radius">
            <img
              class="mx-wd"
              src="../../assets/homeV2/rsz_digital-marketing-new-startup-project-online-search-engine-optimisation.png"
              alt=""
            />

            <div class="" @click="openMarketing()">
              <h3 class="marnope pt-1 cursor-pointer" style="color:#2465F3">
                Digital Marketing >
              </h3>
              <modal
                name="marketing"
                :adaptive="true"
                width="60%"
                height="auto"
              >
                <MoreInfo :info="digitalMarketing" />
              </modal>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MoreInfo from '../Homev2/CategoryInfo.vue'
// import { SweetModal } from 'sweet-modal-vue'
export default {
  data() {
    return {
      dataScience: {
        title: 'Data Science',
        imgUrl: require('../../assets/homeV2/Category/Group 1030.png'),
        quizLink1:
          'https://quiz.upskill.com.bd/assessment/c96bf873-df15-4cb8-b640-ed07ea3f8547?public=true&job=level1DataScience',
        quizLink2:
          'https://quiz.upskill.com.bd/assessment/79ec9cf3-6383-4e82-8a27-0388f5194cce?public=true&job=level2DataScience',
        quizLink3:
          'https://quiz.upskill.com.bd/assessment/ab747a20-d8f1-4bd1-b635-a756139fd462?public=true&job=level3DataScience',
      },
      UXUI: {
        title: 'UX UI',
        imgUrl: require('../../assets/homeV2/Category/Group 1032.png'),
        quizLink1:
          'https://quiz.upskill.com.bd/assessment/a94cbcbc-6f9d-48fc-a0ff-cdf5824ced18?public=true&job=level1UXUI',
        quizLink2:
          'https://quiz.upskill.com.bd/assessment/72adce95-2f7e-4568-b62e-42890afc664f?public=true&job=level2UXUI',
        quizLink3: '',
      },
      frontEnd: {
        title: 'UX UI',
        imgUrl: require('../../assets/homeV2/Category/Group 1031.png'),
        quizLink1:
          'https://quiz.upskill.com.bd/assessment/fa060ca0-6141-4678-88c0-e46f1d729a85?public=true&job=frontendlevel1',
        quizLink2:
          'https://quiz.upskill.com.bd/assessment/b0c1424e-01b5-4c9a-ad8c-6047fe2b697d?public=true&job=frontendlevel2',
        quizLink3: '',
      },
      digitalMarketing: {
        title: 'Digital Marketing',
        imgUrl: require('../../assets/homeV2/Category/Group 1031.png'),
        quizLink1:
          'https://quiz.upskill.com.bd/assessment/241f4f5c-9f5d-42fe-a545-e675d0a1f3d1?public=true&job=digital_marketinglevel1',
        quizLink2:
          'https://quiz.upskill.com.bd/assessment/8ff0a774-7bc0-4fb5-b0fb-f99292450819?public=true&job=digitall_marketinglevel2',
        quizLink3:
          'https://quiz.upskill.com.bd/assessment/3070f1a7-a3eb-4187-85a6-1390b519a853?public=true&job=digital_marketinglevel3',
      },
      modal: false,
    }
  },
  created() {
    this.$refs.modal.close()
  },

  components: {
    MoreInfo,
  },
  methods: {
    openData() {
      this.$modal.show('datas')
    },
    openUx() {
      this.$modal.show('uxui')
    },
    openFront() {
      this.$modal.show('front')
    },
    openMarketing() {
      this.$modal.show('marketing')
    },

    open1() {
      this.$refs.modal1.open()
      this.modal = true
    },
    open2() {
      this.$refs.modal2.open()
      this.modal = true
    },
  },
}
</script>

<style scoped>
.modal {
  visibility: hidden;
  transition: all 0.4s;
  opacity: 0;
}
.modal.open {
  visibility: visible;
  opacity: 1;
}

.modal,
.modal-overlay {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 100vw;
  z-index: 100;
}

.modal,
.modal-card,
.modal-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.modal-content {
  overflow: auto;
  flex-grow: 1;
}

.modal-overlay {
  background: rgba(0, 0, 0, 0.5);
}

.modal-body {
  z-index: 101;
  margin: auto;
  max-height: calc(100vh - 1rem);
  max-width: calc(100vw - 1rem);
  border-radius: 10px;
  overflow: hidden;
  width: 500px;
  height: 200px;
  background: white;
}

.modal-header,
.modal-content,
.modal-footer {
  padding: 1rem;
}

.modal-header {
  background: rebeccapurple;
  text-transform: capitalize;
  font-size: 1.25rem;
  color: white;
  font-weight: bold;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
}

.mx-wd {
  max-width: 400px;
}
.outer-container {
  padding-top: 100px;
}
.heading_fonts {
  font: 800 2.1rem/2.3rem 'Manrope';
  letter-spacing: -2px;
  color: #29292b;
}
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 2rem;
}
.grid > * {
}
.grid > * h2 {
  color: #184dbd;
}

@media (max-width: 767.98px) {
  .mx-wd {
    max-width: 300px;
  }
  .grid {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
  .grid img {
    max-width: 350px;
  }
  .heading_fonts {
    font: 800 1.5rem/1.6rem 'Manrope';
    letter-spacing: 1px;
    color: #29292b;
  }
}
</style>
